<template>
  <v-data-table
    :items="orders"
    :loading="isLoading"
    :hide-headers="hideHeaders"
    :hide-actions="hideActions"
  >
    <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
    <template slot="items" slot-scope="props">
      <td><strong>{{ props.item.btag }}</strong></td>
      <!-- <td>{{ props.item.client && props.item.client.name }}</td> -->
      <td>{{ props.item.device && props.item.device.name }}</td>
      <td>{{ props.item.price }} руб.</td>
      <td>{{ statusById[props.item.status] || 'No  status' }}</td>
      <td>
        <v-btn
          v-if="props.item.status === 1"
          color="success"
          @click="onMakeRequest(props.item.btag)"
        >
          Выкупить
        </v-btn>
      </td>
    </template>
  </v-data-table>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    orders: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    hideActions: {
      default: false,
      type: Boolean,
    },
    hideHeaders: {
      default: true,
      type: Boolean,
    },
    onMakeRequest: {
      default: () => {},
      type: Function,
    },
  },
  computed: mapGetters('statuses', ['statusById']),
};
</script>
